module.exports = "/_next/static/images/CollectDataTabs-1-xs@2x-c945b69018bb5dcac2f07304589816f6.webp";